import axios from 'axios';

export function getCountry(callback, errorcallback) {
  axios
    .get('api/country')
    .then((response) => {
      if (response.status == 200) {
        callback(response.data);
      }
    })
    .catch((error) => {
      errorcallback(error);
    });
}
